/* eslint-disable i18next/no-literal-string -- const definitions are the source of truth */
/**
 * Backend-aligned types for the script_execute_log admin view.
 * Mirrors {@code ScriptExecuteLogResponse} on the Java side.
 */
import type {Instant, UUID} from './common'
import type {Page} from './page'

export const ScriptExecuteLogMode = {
    preview: 'preview',
    runtime: 'runtime',
} as const

export type ScriptExecuteLogMode = typeof ScriptExecuteLogMode[keyof typeof ScriptExecuteLogMode]

export interface ScriptExecuteLog {
    id: UUID
    occurredAt: Instant
    actorUserId: UUID | null
    actorUsername: string | null
    jobExecutionId: UUID | null
    mode: ScriptExecuteLogMode
    sqlText: string
    durationMs: number | null
    success: boolean
    errorCode: string | null
    errorMessage: string | null
}

export type ScriptExecuteLogPage = Page<ScriptExecuteLog>
